import { combineReducers } from 'redux';

import languageReducer from 'containers/LanguageProvider/reducer';

import ConstantReducer from 'aurora-composition/modules/constant/reducer';
import RegisterDisputeReducer from 'aurora-composition/modules/RegisterDispute/reducer';
import RequestForExpertOpinion from 'aurora-composition/modules/RequestForExpertOpinion/reducer';
import authReducer from './modules/authentication/reducer';
import dashboardHomeReducer from './modules/home/reducer';
import propertiesReducer from './modules/properties/reducer';
import walletReducer from './modules/wallet/reducer';
import paymentReducer from './modules/payment/reducer';
import userReducer from './modules/user/reducer';
import serviceReducer from './modules/service/reducer';
import applicationReducer from './modules/application/reducer';
import tasksListReducer from './modules/tasks/reducer';
import leaseReducer from './modules/lease/reducer';
import sellPurchaseReducer from './modules/sellPurchase/reducer';
import sellPurchaseApplicationReducer from './modules/sellPurchase/application/reducer';
import LeaseApplicationReducer from './modules/lease/application/reducer';
import auroraUiReducer from './actions/auroraUiReducer';
import contractReducer from './modules/contracts/reducer';
import employeeReducer from './modules/employee/reducer';
import certificatesReducer from './modules/certificates/reducer';
import directoryReducer from './modules/directory/reducer';
import pmaReducer from './modules/pma/reducer';
import pmaAppllicationReducer from './modules/pma/application/reducer';
import musatahaReducer from './modules/musataha/reducer';
import offPlanReducer from './modules/offPlanTransaction/reducer';
import buyersListReducer from './modules/buyersList/reducer';
import musatahaApplicationReducer from './modules/musataha/application/reducer';
import musatahaReducerPost from './modules/musataha/applicationWaiver/reducer';
import offPlanReducerPost from './modules/offPlanTransaction/application/reducer';
import mortgageReducer from './modules/mortgage/reducer';
import primaryContactReducer from './modules/primaryContact/reducer';
import filtersReducer from './modules/filters/reducer';
import transferOffPlanReducer from './modules/transferOffPlan/reducer';
import nhlMortgageReducer from './modules/nhlMortgage/reducer';
import RentPaymentReducer from './modules/rentPayment/reducer';
import OffPlanTerminationReducer from './modules/OffPlanTermination/reducer';
import developerReducers from './modules/developers/reducer';
import commonReducer from './modules/common/reducer';
import OffPlanProjectRegistrationReducer from './modules/offPlanProjectRegistration/reducer';
import RequestExecutionStampReducer from './modules/RequestExecutionStamp/reducer';
import AddCompanyEmployeeReducer from './modules/addCompanyEmployee/reducer';
import EscrowAccountReducer from './modules/escrowAccountDetails/reducer';
import EscrowServiceProviderPaymentReducer from './modules/escrowServiceProviderPayment/reducer';
import registerCompanyReducer from './modules/registerCompany/reducer';
import updateCompanyReducer from './modules/updateCompanyProfile/reducer';
import ProfessionRegistrationReducer from './modules/professionRegistration/reducer';
import offPlanBuySellReducer from './modules/offPlanBuySell/reducer';
import ReleaseMortgageReducer from './modules/releaseMortgage/reducer';
import PermitReducer from './modules/permits/reducer';
import PowerOfAttorneyReducer from './modules/PowerOfAttorney/reducer';
import musatahaContractRegistrationReducer from './modules/musatahaContractRegistration/reducer';
import manualProfileCreationReducer from './modules/manualProfileCreation/reducer';
import instantServicesReducer from './modules/instantServices/reducer';
import MortgageModificationReducer from './modules/mortgageModification/reducer';
import TransferOfInterestReducer from './modules/transferOfInterest/reducer';
import DigitalTransferOfInterestReducer from './modules/digitalTransferOfInterest/reducer';

export default function createReducer(injectedReducers = {}) {
  const appReducer = combineReducers({
    ui: auroraUiReducer,
    authReducer,
    dashboardHomeReducer,
    propertiesReducer,
    walletReducer,
    userReducer,
    serviceReducer,
    applicationReducer,
    tasksListReducer,
    paymentReducer,
    leaseReducer,
    sellPurchaseReducer,
    LeaseApplicationReducer,
    sellPurchaseApplicationReducer,
    contractReducer,
    employeeReducer,
    certificatesReducer,
    directoryReducer,
    pmaReducer,
    pmaAppllicationReducer,
    musatahaReducer,
    offPlanReducer,
    musatahaApplicationReducer,
    musatahaReducerPost,
    offPlanReducerPost,
    buyersListReducer,
    primaryContactReducer,
    filtersReducer,
    transferOffPlanReducer,
    nhlMortgageReducer,
    RentPaymentReducer,
    OffPlanTerminationReducer,
    RegisterDisputeReducer,
    RequestForExpertOpinion,
    language: languageReducer,
    ...injectedReducers,
    mortgageReducer,
    developerReducers,
    ConstantReducer,
    commonReducer,
    OffPlanProjectRegistrationReducer,
    RequestExecutionStampReducer,
    AddCompanyEmployeeReducer,
    EscrowAccountReducer,
    EscrowServiceProviderPaymentReducer,
    registerCompanyReducer,
    updateCompanyReducer,
    ProfessionRegistrationReducer,
    offPlanBuySellReducer,
    ReleaseMortgageReducer,
    PermitReducer,
    PowerOfAttorneyReducer,
    musatahaContractRegistrationReducer,
    manualProfileCreationReducer,
    instantServicesReducer,
    MortgageModificationReducer,
    TransferOfInterestReducer,
    DigitalTransferOfInterestReducer,
  });
  const rootReducer = (state, action) => {
    if (action?.type === 'LOGOUT_SUCCESS') {
      return appReducer(undefined, action);
    }
    return appReducer(state, action);
  };
  return rootReducer;
}
